import { render, staticRenderFns } from "./VAudio.vue?vue&type=template&id=b11fd130&scoped=true&"
import script from "./VAudio.vue?vue&type=script&lang=js&"
export * from "./VAudio.vue?vue&type=script&lang=js&"
import style0 from "./VAudio.vue?vue&type=style&index=0&id=b11fd130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11fd130",
  null
  
)

export default component.exports